export default "__VITE_ASSET__DHL4k9su__"